module.exports = __webpack_public_path__ + "static/media/lithium.6f0d80eb.svg";